var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 6H2.4C2.36599 6 2.28477 6.01315 2.18953 6.11898C2.08803 6.23175 2 6.42582 2 6.66667V17.3333C2 17.5742 2.08803 17.7682 2.18953 17.881C2.28477 17.9868 2.36599 18 2.4 18H21.6C21.634 18 21.7152 17.9868 21.8105 17.881C21.912 17.7682 22 17.5742 22 17.3333V6.66667C22 6.42582 21.912 6.23175 21.8105 6.11898C21.7152 6.01315 21.634 6 21.6 6ZM2.4 4H21.6C22.2365 4 22.847 4.28095 23.2971 4.78105C23.7471 5.28115 24 5.95942 24 6.66667V17.3333C24 18.0406 23.7471 18.7189 23.2971 19.219C22.847 19.719 22.2365 20 21.6 20H2.4C1.76348 20 1.15303 19.719 0.702944 19.219C0.252856 18.7189 0 18.0406 0 17.3333V6.66667C0 5.95942 0.252856 5.28115 0.702944 4.78105C1.15303 4.28095 1.76348 4 2.4 4Z",
    fill: "#0973F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14V16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16V14",
    stroke: "#0973F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15V8",
    stroke: "#00AEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L12 8L10 10",
    stroke: "#00AEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadButton);
export default __webpack_public_path__ + "static/media/fileUploadButton.738e0232.svg";
export { ForwardRef as ReactComponent };